export const handleHolidayArr = (arr?: string[]) =>
  arr &&
  arr.map(
    (date) =>
      new Date(new Date(date).setMinutes(new Date(date).getTimezoneOffset())),
  );
